import { Icon } from "@nabble/ui";
import type { PolicyCheck } from "./PasswordPolicy";

/** The password requirements, each one ticked as soon as it is met. */
export function PasswordChecklist({ checks }: { checks: PolicyCheck[] }): React.JSX.Element {
  return (
    <ul className="nb-checklist" aria-label="Password requirements">
      {checks.map((c) => (
        <li key={c.label} className={c.ok ? "is-ok" : undefined}>
          <Icon name={c.ok ? "checkCircle" : "circle"} />
          <span>{c.label}</span>
          <span className="nb-sr">{c.ok ? "(met)" : "(not met yet)"}</span>
        </li>
      ))}
    </ul>
  );
}
